import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _class, _descriptor;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { observable, action } from 'mobx';
import TeamCreditViewState from './TeamCreditViewState';
var TeamBillingViewState = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _class = /*#__PURE__*/function () {
  function TeamBillingViewState(_ref) {
    var team = _ref.team,
      billingStore = _ref.billingStore,
      flashMessageStore = _ref.flashMessageStore,
      jobStore = _ref.jobStore,
      memberStore = _ref.memberStore;
    _classCallCheck(this, TeamBillingViewState);
    _initializerDefineProperty(this, "showingCreateBillingModal", _descriptor, this);
    this.team = team;
    this.billingStore = billingStore;
    this.flashMessageStore = flashMessageStore;
    this.creditViewState = new TeamCreditViewState({
      team: team,
      billingStore: billingStore,
      flashMessageStore: flashMessageStore,
      jobStore: jobStore,
      memberStore: memberStore
    });
  }
  return _createClass(TeamBillingViewState, [{
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
    /**
     * Adds a billing method.
     */
  }, {
    key: "addBillingMethod",
    value: function addBillingMethod() {
      this.showingCreateBillingModal = false;
      return this.billingStore.showStripeCheckout({
        team: this.team
      });
    }
  }, {
    key: "addCreditBillingMethod",
    value: function () {
      var _addCreditBillingMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var msg;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              msg = this.flashMessageStore.create({
                message: 'Creating credit account...',
                inProgress: true
              });
              _context2.prev = 1;
              _context2.next = 4;
              return this.billingStore.addCreditMethod({
                team_id: this.team.id,
                workspace_id: this.team.workspaceId,
                type: 'Credit'
              });
            case 4:
              this.hideCreateBillingModal();
              msg.done('Credit account has been created!').autoDismiss();
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              throw msg.forError(_context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 8]]);
      }));
      function addCreditBillingMethod() {
        return _addCreditBillingMethod.apply(this, arguments);
      }
      return addCreditBillingMethod;
    }()
    /**
     * Add a team payout method.
     */
  }, {
    key: "addPayoutMethod",
    value: function addPayoutMethod() {
      this.billingStore.redirectToStripeConnect(this.team);
    }

    /**
     * Sets the default team billing method.
     * @param {*} method
     */
  }, {
    key: "setDefaultTeamBillingMethod",
    value: function setDefaultTeamBillingMethod(method) {
      return this.billingStore.changeDefaultBillingMethod(method, this.team);
    }

    /**
     * Sets the default team billing method.
     * @param {*} method
     */
  }, {
    key: "setDefaultTeamPayoutMethod",
    value: function setDefaultTeamPayoutMethod(method) {
      return this.billingStore.changeDefaultPayoutMethod(method, this.team);
    }
  }, {
    key: "showCreateBillingModal",
    value: function showCreateBillingModal() {
      this.showingCreateBillingModal = true;
    }
  }, {
    key: "hideCreateBillingModal",
    value: function hideCreateBillingModal() {
      this.showingCreateBillingModal = false;
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showingCreateBillingModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "addBillingMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addBillingMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addCreditBillingMethod", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "addCreditBillingMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCreateBillingModal", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "showCreateBillingModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideCreateBillingModal", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "hideCreateBillingModal"), _class.prototype), _class);
export { TeamBillingViewState as default };
//# sourceMappingURL=TeamBillingViewState.js.map
